// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".largeFont {\n  font-size: 5.5rem;\n  color: #AAAAAA;\n}\n", ""]);
// Exports
module.exports = exports;
